const SpinningLoader = () => {
  return (
    <div className="inline-flex h-8 w-8 animate-[spin-pulse_0.75s_0s_infinite_linear] justify-center rounded-full border-2 border-primary-700 border-b-transparent" />
  )
}

export default SpinningLoader
